var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-plyr',{ref:"plyr",attrs:{"options":_vm.options}},[_c('video',{attrs:{"controls":"","crossorigin":"","playsinline":""}},[_c('source',{attrs:{"src":_vm.src.url,"type":_vm.src.mime}})])])}
var staticRenderFns = []

export { render, staticRenderFns }